import React from "react";
import { Dialog, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

/**
 * ImageModal Component
 *
 * Displays a full-size preview of an image in a modal.
 *
 * @param {boolean} open - Whether the modal is open
 * @param {string|null} imageURL - URL of the image to display
 * @param {Function} onClose - Function to close the modal
 */
const ImageModal = ({ open, imageURL, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md">
      <DialogContent sx={{ position: "relative", textAlign: "center" }}>
        {/* ❌ Close button */}
        <IconButton
          onClick={onClose}
          sx={{ position: "absolute", top: 8, right: 8 }}
        >
          <CloseIcon />
        </IconButton>

        {/* 🖼 Display the full image */}
        {imageURL ? (
          <img
            src={imageURL}
            alt="Preview"
            style={{
              width: "100%",
              maxHeight: "90vh",
              objectFit: "contain",
            }}
          />
        ) : (
          <p>No image to preview</p>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ImageModal;
